import TopArea from "../../../../components/TopArea";
import { useApiData } from "../../context/ApiDataContext";
import video from "../../images/video.mp4";
import AboutArea from "../AboutArea";
import ChooseArea from "../ChooseArea";
import DashboardArea from "../DashboardArea";
import License from "../License";
import styles from "./style.module.scss";

const AboutContainer = () => {
  const { data } = useApiData();

  return (
    <div className={`${styles.about} about`}>
      <div className={styles.container}>
        <TopArea data={data} showButton={false} />
        <AboutArea />
        <DashboardArea />
        <video className={styles.video} autoplay="autoplay" muted loop="true" playsinline="true">
          <source src={video} type="video/mp4" />
        </video>
        <License data={data?.company_info} />
        <ChooseArea />
      </div>
    </div>
  );
};

export default AboutContainer;
